import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/site";
import { episodes } from "@/mocks/episodes";
import { articles } from "@/mocks/articles";
import { specials } from "@/mocks/specials";

export default function About() {
  useSeo({
    title: "关于本站 - 朋友的妈妈3影视专站",
    description:
      "了解「朋友的妈妈3影视专站」的定位、服务内容、版权与免责声明，以及联系方式与反馈入口。",
    keywords: "朋友的妈妈3关于,朋友的妈妈3版权,朋友的妈妈3声明",
  });

  const services = [
    { icon: "ri-book-open-line", title: "剧情介绍", desc: "按章节整理完整剧情脉络，支持目录锚点快速定位。" },
    { icon: "ri-newspaper-line", title: "影视资讯", desc: "官方发布、剧情解读与幕后制作动态，一站式浏览。" },
    { icon: "ri-search-line", title: "内容搜索", desc: "按关键词检索剧情与资讯，快速找到想看的内容。" },
    { icon: "ri-stack-line", title: "深度专题", desc: "将文章按主题分组，便于系统性地了解这部作品。" },
  ];

  const stats = [
    { value: `${episodes.length}`, label: "剧情章节" },
    { value: `${articles.length}`, label: "资讯文章" },
    { value: `${specials.length}`, label: "深度专题" },
    { value: "3", label: "参与主创" },
  ];

  return (
    <>
      <section className="w-full bg-primary-950 px-4 md:px-6 py-12 md:py-16">
        <nav className="w-full text-sm text-background-100/60 mb-4" aria-label="面包屑">
          <ol className="flex items-center gap-2 flex-wrap">
            <li>
              <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
                首页
              </Link>
            </li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li className="text-background-50">关于本站</li>
          </ol>
        </nav>
        <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
          关于本站
        </h1>
        <p className="mt-3 text-sm md:text-base text-background-100/75 max-w-3xl leading-relaxed">
          {siteInfo.brandFull}——专注《朋友的妈妈3》的专题影视内容站，为喜爱这部作品的观众提供
          剧情查询、资讯浏览与资料整理服务。
        </p>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 max-w-3xl">
          {stats.map((item) => (
            <div key={item.label} className="rounded-lg bg-background-50/10 border border-background-50/15 p-4">
              <p className="font-label text-2xl md:text-3xl font-semibold text-accent-400">{item.value}</p>
              <p className="mt-1 text-xs md:text-sm text-background-100/70">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((item) => (
            <div
              key={item.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/80"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-2xl mb-4">
                <i className={item.icon}></i>
              </span>
              <h2 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h2>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
          <div className="rounded-lg bg-background-50 border border-background-200/80 p-6 md:p-8">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-copyright-line text-accent-500"></i>
              版权声明
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                本站为《朋友的妈妈3》的专题内容展示站，站内展示的剧情、资讯、图片与文字均为虚构演示内容，
                仅用于产品功能与界面演示。
              </p>
              <p>
                本站不提供任何影视作品的在线播放、下载、会员与付费服务，也不存储任何影视资源。
              </p>
              <p>
                如本站内容无意中侵犯了您的权益，请通过下方联系方式与我们联系，我们将及时处理。
              </p>
            </div>
          </div>

          <div className="rounded-lg bg-background-50 border border-background-200/80 p-6 md:p-8">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-500"></i>
              免责声明
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                站内搜索、筛选与排序功能均为前端模拟演示，没有真实的接口或后台数据支撑，
                搜索结果仅代表演示数据的匹配情况。
              </p>
              <p>
                站内「分享」按钮仅为示意性交互，点击后不会真正分享到第三方平台。
              </p>
              <p>
                本站内容仅供影迷交流学习使用，用户据此产生的任何行为与本网站无关。
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
        <div className="rounded-lg bg-primary-950 p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50">
                联系与反馈
              </h2>
              <p className="mt-3 text-sm text-background-100/70 leading-relaxed">
                如果你对本站有任何建议、内容纠错或合作意向，欢迎通过邮件与我们联系。
              </p>
              <a
                href={`mailto:${siteInfo.contactEmail}`}
                className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 hover:bg-accent-600 text-primary-950 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line"></i>
                发送邮件
              </a>
            </div>
            <div className="rounded-lg bg-background-50/10 border border-background-50/15 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/15 text-accent-400">
                  <i className="ri-mail-line text-xl"></i>
                </span>
                <div className="min-w-0">
                  <p className="text-xs text-background-100/60">联系邮箱</p>
                  <a
                    href={`mailto:${siteInfo.contactEmail}`}
                    className="text-sm text-background-50 hover:text-accent-400 transition-colors cursor-pointer break-all"
                  >
                    {siteInfo.contactEmail}
                  </a>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/15 text-accent-400">
                  <i className="ri-time-line text-xl"></i>
                </span>
                <div>
                  <p className="text-xs text-background-100/60">回复时间</p>
                  <p className="text-sm text-background-50">工作日 1-2 日内回复</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}